import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/pro-duotone-svg-icons";
import { faClock } from "@fortawesome/pro-duotone-svg-icons";
 
const ReportQueueIcon = () => {
  return (
    <div style={{ position: "relative",  right: 6}}>
    <span className="fa-stack">
      <FontAwesomeIcon icon={faClock} className="fa-stack-1x" style={{ "--fa-primary-color": "#273349", "--fa-primary-opacity": "1","--fa-secondary-color": "#96a3bb", "--fa-secondary-opacity": "1", right: -17, width: 15, height: 15, zIndex: 2}}/>
      <FontAwesomeIcon icon={faChartLine} className="fa-stack-2x" style={{  color: "white", bottom: 0, left: 5,  width: 28, height: 28, zIndex: 1}}/>
    </span>
    </div>
  );
};
 
export default ReportQueueIcon;